import { createRouter, createWebHistory } from 'vue-router';
const routes = [
    {
        path: '/',
        name: 'Home',
        component: () => import('../views/HomePage.vue')
    },
    {
        path: '/blog/:id',
        name: 'BlogPost',
        component: () => import('../views/BlogPost.vue'),
        props: true
    },
    {
        path: '/game/:id',
        name: 'Game',
        component: () => import('../views/GamePage.vue'),
        props: true
    },
    {
        path: '/vacancies',
        name: 'Vacancies',
        component: () => import('../views/VacanciesPage.vue'),
        props: true
    },
    {
        path: '/congratulations',
        name: 'Congratulations',
        component: () => import('../views/CongratulationsPage.vue'),
        props: true
    },
    {
        path: '/stoprighttherecriminalscum',
        name: 'StopRightThereCriminalScum',
        component: () => import('../views/StopRightThereCriminalScumPage.vue'),
        props: true
    },
    {
        path: '/:pathMatch(.*)*',
        name: 'NotFound',
        component: () => import('../views/NotFoundPage.vue'),
        props: true
    },
];
const router = createRouter({
    history: createWebHistory(),
    routes
});
export default router;
